import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link} from 'react-router-dom';
import { Trans } from 'react-i18next';

import { LoadingIcon } from '../Common/Loading_Icon';

//A React component will allow us to quickly iterate and change our code. It provides 
class EUOEMBanner extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.scrollToVehicles = this.scrollToVehicles.bind(this);
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    scrollToVehicles() {
        $('.eu-mainsection').animate({
            scrollTop: ($('.search-field-container').first().offset().top)
        },500);
    }

    render() {
        return (
            this.props.loading ?
                <LoadingIcon />
            :
                Object.keys(this.props.banner).length > 0 ?
                    <>
                        {
                            this.props.banner.fallback_image ?
                                <div className="eu-oem-mainsection-banner" style={{height: 'auto'}}>
                                    <video playsInline autoPlay muted loop poster={ this.props.banner.fallback_image } id="eu-oem-mainsection-banner-video" style={ this.props.banner.image_css ? JSON.parse(this.props.banner.image_css) : {}}>
                                        <source src={ this.props.banner.video_source } type={ this.props.banner.video_type } />
                                        <img src={ this.props.banner.fallback_image } />
                                    </video>
                                    <div className= "eu-oem-mainsection-banner-content" style={ this.props.banner.banner_content_css ? JSON.parse(this.props.banner.banner_content_css) : {}}>
                                        <div style={ this.props.banner.banner_text_css ? JSON.parse(this.props.banner.banner_text_css) : {}}>
                                        <h1 dangerouslySetInnerHTML={{__html: this.props.banner.banner_header}} />
                                        {
                                            this.props.banner.banner_text ?
                                                <p>{ this.props.banner.banner_text }</p>
                                            :
                                                null
                                        }
                                        </div>
                                        <br />
                                        <div style={ this.props.banner.banner_links_css ? JSON.parse(this.props.banner.banner_links_css) : {}}>
                                        {
                                            (this.props.banner.button_1_link && this.props.banner.button_1_text) || (this.props.banner.button_2_link && this.props.banner.button_2_text) ?
                                                <>
                                                    {
                                                        this.props.banner.button_1_link && this.props.banner.button_1_text ?
                                                            <Link to ={this.props.banner.button_1_link} className="button ">{ this.props.banner.button_1_text }</Link>
                                                        :
                                                            null
                                                    }
                                                    {
                                                        (this.props.banner.button_1_link && this.props.banner.button_1_text) && (this.props.banner.button_2_link && this.props.banner.button_2_text) && (this.props.banner.button_2_on_new_line && this.props.banner.button_2_on_new_line == 'true') ?
                                                            <br />
                                                        :
                                                            null
                                                    }
                                                    {
                                                        this.props.banner.button_2_link && this.props.banner.button_2_text ?
                                                            this.props.banner.button_2_link == "#vehicles" ?
                                                                <a onClick={this.scrollToVehicles} className={"button see-through" + ((this.props.banner.button_1_link && this.props.banner.button_1_text) && (this.props.banner.button_2_link && this.props.banner.button_2_text) && (!this.props.banner.button_2_on_new_line || this.props.banner.button_2_on_new_line == 'false') ? " ml-16" : "")}>{ this.props.banner.button_2_text }</a>
                                                            :
                                                                <a href={this.props.banner.button_2_link} className={"button see-through" + ((this.props.banner.button_1_link && this.props.banner.button_1_text) && (this.props.banner.button_2_link && this.props.banner.button_2_text) && (!this.props.banner.button_2_on_new_line || this.props.banner.button_2_on_new_line == 'false') ? " ml-16" : "")}>{ this.props.banner.button_2_text }</a>   
                                                        :
                                                            null
                                                    }
                                                </>
                                            :
                                                null
                                        }
                                        </div>
                                    </div>
                                </div>
                            :
                                null
                        }
                        {this.props.banner.welcome_header && this.props.banner.welcome_text && (
                            <div className="eu-oem-mainsection-blurb">
                                <h1><Trans>{this.props.banner.welcome_header}</Trans></h1>
                                <p dangerouslySetInnerHTML={{ __html: this.props.banner.welcome_text }} />
                            </div>
                        )}
                    </>
                :
                    null
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
});

export default connect(mapStateToProps)(EUOEMBanner);